import 'twin.macro';

import { Button, Link, Page, Stack, Text } from '@cheqroom/ui';
import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { StyledCard } from '../../App.styles';
import { AuthFlowHeader } from '../AuthFlowHeader';

const toCookieHelpPage = 'https://knowledge.cheqroom.com/helpcenter';

export const CookieErrorPage: FC = () => {
	const { t } = useTranslation('login-error');

	const handleRefreshPageClick = () => {
		window.location.reload();
	};

	return (
		<Page variant="viewportCentered">
			<Page.Content>
				<StyledCard sectioned>
					<Stack align="center" spacing="extraLoose" vertical>
						<AuthFlowHeader heading={t('cookie_page.heading')} subheading={t('cookie_page.subtext')} />

						<Text color="subdued" size="small" align="center">
							<Trans
								i18nKey="cookie_page.need_help"
								ns="login-error"
								components={[
									<Link inheritSize key="0" url={toCookieHelpPage} external>
										placeholder
									</Link>,
								]}
							/>
						</Text>

						<Button onClick={handleRefreshPageClick} size="medium" type="submit" tw="w-full">
							{t('cookie_page.refresh')}
						</Button>
					</Stack>
				</StyledCard>
			</Page.Content>
		</Page>
	);
};
